class navHelper {

	init() {
    }
    
    slideOutMenu() {
        // mobile menu slide from the right
        $('.toggle').on('click', function(e) {
            $toggle_target = $($(this).data('toggle'));
            $toggle_target.toggleClass('open');
            $(this).toggleClass('open');
            setTimeout(function() {
                $('body').toggleClass('noscroll');
            }, 1000);
            setTimeout(function() {
                $('html').toggleClass('noscroll');
            }, 1000);
            $toggle_target.find('a:first').focus();
            e.preventDefault();
        });
    }

    searchModal(){
        // $('.search-link').on('click', function(e){
        //     e.preventDefault();
        //     $toggle_target = $($(this).data('target'));
        //     console.log($toggle_target.find('input#s'));
        //     // $toggle_target.find('input#s').focus();
        //     // $toggle_target.find('input#s').focus().val("How Did This Happen ?").focus();
            
        // });
        $('#search-modal').on('shown.bs.modal', function() {
            $(this).find('input#s').focus();
          });
    }

    pageHeader(){
        const height = document.querySelector('nav').offsetHeight;
        const padding_top = parseInt($('#pageHeaderPaddingDiv').css('padding-top')) + height;
        $('#pageHeaderPaddingDiv').css('padding-top', padding_top);
        // console.log(padding_top);
    }
}

window.app.add('nav', new navHelper()); 